
import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application';
import { apiurl } from '../../../../path';
import { Link } from 'react-router-dom';
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../public/LoginImages/importimages';


const AdministrativeApprovalInwards = () => {
    const context = useContext(AdminContext)
    const { GetAdminApprovalInwardsList, AdministrativeApproveOperation } = context;

    const [technicalInwards, setTechnicalInwards] = useState([])
    const [loading, setLoading] = useState(false);
    const [selectedBills, setSelectedBills] = useState([]);
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const [rejectPanelhide, setRejectpanelhide] = useState(1);
    const [remark, setRemark] = useState("");

    const getTechnicalInwardsList = async () => {
        let data = await GetAdminApprovalInwardsList('All', 'null')
        console.log("data------------", data);

        setTechnicalInwards(data)
        setFilteredBills(data);
    }

    useEffect(() => {
        getTechnicalInwardsList()
    }, []);

    let inwardList = []
    if (technicalInwards.length > 0) {
        inwardList = technicalInwards
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = technicalInwards.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [searchTerm, technicalInwards]);



    const handleCheckboxChange = (id) => {
        setSelectedBills((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((billId) => billId !== id)
                : [...prevSelected, id]
        );
    };

    console.log("Slected id form table :: ", selectedBills);
    console.log("Filtered data id form table :: ", filteredBills);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedBills(currentBills.map((bill) => bill.AdminApprovalID));
        } else {
            setSelectedBills([]);
        }
    };


    const approveorrejectSelected = async (condition) => {
        if (selectedBills.length === 0) {
            alert('No Proposal selected for approval!');
            return;
        }
        console.log(selectedBills);
        setLoading(true); // Start loader
        try {
            let response = await AdministrativeApproveOperation(selectedBills, condition, remark); // Call backend function
            if (response.message) {
                alert(response.message);
                getTechnicalInwardsList();
                setRejectpanelhide(1);
                setRemark("");
            }
            if (response.error) {
                alert(response.error)
                getTechnicalInwardsList();
                setRejectpanelhide(1);
                setRemark("");
            }
        } catch (error) {
            console.error('Error approving Proposal:', error);
            alert('An error occurred while approving bills.');
            setRejectpanelhide(1);
            setRemark("");
        }
        setLoading(false); // Stop loader
    };


    const showrjectpanelforrjectorsendback = (id) => {
        if (selectedBills.length > 0) {
            setRejectpanelhide(id);
        }
        else {
            alert("No Bills Selected !!!");
        }
    }

    console.log("adminapproval inward ",technicalInwards)
    return (

        <>


            <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll"}}>
                <div className="col-11 m-auto">

                    <div className="col-12">

                        <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
                            <h5 className='my-auto fw-bold'>
                                <img src="/GR-Approval64.png" alt="Administrative Approval Inwards" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                <span className='my-auto'>Administrative Approval Inwards</span>
                            </h5>

                            <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                <img
                                    src="/Search32.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "10px",
                                        transform: "translateY(-50%)",
                                        width: "16px",
                                        height: "16px",
                                        opacity: 0.6
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder="Search Here"
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    value={searchTerm}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px 8px 32px", // left padding makes space for icon
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        backgroundColor: "#f1f6fc",
                                        fontSize: "14px",
                                        color: "#333",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                        outline: "none"
                                    }}
                                />
                            </div>
                        </div>


                        <div className="col-12 pb-5">
                            <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%",maxWidth:"100%",overflowX:"hidden" }}>
                                <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                                    <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                <th style={{ minWidth: "60px", padding: "8px" }}><input
                                                    type="checkbox"
                                                    onChange={handleSelectAll}
                                                    checked={selectedBills.length === currentBills.length}
                                                    style={{ marginRight: '5px', height: '1.1rem', width: '1.1rem' }}
                                                />
                                                </th>
                                                {/* <th style={{ width: '8%' }}>View</th> */}
                                                <th style={{ minWidth: "190px", padding: "8px" }}>Administrative Approval UID</th>
                                                <th style={{ minWidth: "130px", padding: "8px" }}>HeadCode</th>
                                                <th style={{ minWidth: "130px", padding: "8px" }}>Financial Year</th>
                                                <th style={{ minWidth: "130px", padding: "8px" }}>GR UID</th>
                                                <th style={{ minWidth: "130px", padding: "8px" }}>Technical UID</th>
                                                <th style={{ minWidth: "130px", padding: "8px" }}>Taluka</th>
                                                    <th style={{ minWidth: "130px", padding: "8px" }}>GramPanchayat</th>
                                                <th style={{ minWidth: "130px", padding: "8px" }}>WorkName</th>
                                                <th style={{ minWidth: "200px", padding: "8px" }}>Government Approval Number</th>
                                                <th style={{ minWidth: "130px", padding: "8px" }}>Amount</th>
                                                <th style={{ minWidth: "190px", padding: "8px" }}>Government Approval Date</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>Government Order No</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>Government Order Date</th>
                                                <th style={{ minWidth: "190px", padding: "8px" }}>Government Order End Date</th>
                                                <th style={{ minWidth: "260px", padding: "8px" }}>Admin Approval Copy</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentBills?.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="20" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                            No data available
                                                        </td>
                                                    </tr>
                                                ) : (

                                                    currentBills?.map((technicalInwards, index) => {
                                                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                        return (
                                                            <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
                                                                <td style={{ padding: '8px' }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        style={{ marginRight: '5px', height: '1.1rem', width: '1.1rem' }}
                                                                        checked={selectedBills.includes(technicalInwards.AdminApprovalID)}
                                                                        onChange={() => handleCheckboxChange(technicalInwards.AdminApprovalID)}
                                                                    />
                                                                </td>
                                                                {/* <td className='py-2'><Link to={`/AdminDashboard/ProposalApprove/${technicalInwards.ProposalID}`}>View</Link></td> */}
                                                                {/* <td style={{ padding: '8px' }}><Link to={`/AdminDashboard/AdminstrativeApproval/${technicalInwards.AdminApprovalID}`}>View</Link></td> */}
                                                                <td style={{ padding: '8px' }}>{technicalInwards.AdminApprovalID}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.HeadCode}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.AdminApprovalYear}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.GRUID}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.TechnicalUID}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.Taluka}</td>
                                                                 <td style={{ padding: '8px' }}>{technicalInwards.GramPanchayat}</td>
                                                                 <td style={{ padding: '8px' }}>{technicalInwards.WorkName}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.GovernmentApprovalNumber}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.Amount}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.GovernmentApprovalDate?.split('T')[0].replace(' ')}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.GovernmentOrderNo}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.GovernmentOrderDate?.split('T')[0].replace(' ')}</td>
                                                                <td style={{ padding: '8px' }}>{technicalInwards.GovernmentOrderEndDate?.split('T')[0].replace(' ')}</td>

                                                                <td style={{ padding: '8px' }}>{
                                                                    technicalInwards.AdminApprovalCopy ?
                                                                        (<a href={`${apiurl}/AdminApprovalCopy/${technicalInwards.AdminApprovalCopy}`} target='_blank'>{technicalInwards.AdminApprovalCopy}</a>)
                                                                        :
                                                                        (<p className='text-danger my-auto fw-bold'>No Copy</p>)
                                                                }
                                                                </td>


                                                            </tr>
                                                        )
                                                    })
                                                )
                                            }
                                        </tbody>
                                    </table>

                                </div>

                                <div className='col-12 mt-3'>
                                    <div
                                        className="my-2 d-flex justify-content-between align-items-center"
                                        style={{ flexWrap: "wrap" }}
                                    >

                                        <p>Showing {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}  to {Math.min(indexOfLastBill, filteredBills?.length)} of {filteredBills?.length} entries</p>
                                        <div className="col-6 text-end">

                                            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
                                                &laquo;
                                            </button>
                                            {/* Previous Button */}
                                            <button
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &lt;
                                            </button>

                                            <button
                                                style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                                            </button>
                                            {/* Next Button */}
                                            <button
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &gt;
                                            </button>
                                            {/* Last Page Button */}
                                            <button
                                                onClick={() => setCurrentPage(totalPages)}
                                                disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &raquo;
                                            </button>
                                        </div>
                                        <div className='col-6 text-start' style={{ display: 'flex', justifyContent: 'left' }}>
                                            <button
                                                onClick={() => approveorrejectSelected("Approved")}
                                                disabled={selectedBills.length <= 0 ? true : loading}
                                                className='ms-0'
                                                style={{
                                                    display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                    backgroundColor: selectedBills.length <= 0 ? (
                                                        'rgba(141, 141, 141, 0.97)'
                                                    ) : ('#39B54A'),
                                                    color: 'white', borderRadius: '8px',
                                                    cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                                }}>
                                                <img src='/Approve-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
                                            </button>

                                            <button
                                                onClick={() => showrjectpanelforrjectorsendback(2)}
                                                disabled={selectedBills.length <= 0 ? true : loading}
                                                style={{
                                                    display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                    background: selectedBills.length <= 0 ? (
                                                        'rgba(141, 141, 141, 0.97)'
                                                    ) : ('#C1272D'),
                                                    color: 'white', borderRadius: '8px',
                                                    cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                                }}
                                            ><img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Reject Selected'}
                                            </button>

                                            <button
                                                onClick={() => showrjectpanelforrjectorsendback(3)} disabled={selectedBills.length <= 0 ? true : loading}
                                                style={{
                                                    display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                    background: selectedBills.length <= 0 ? (
                                                        'rgba(141, 141, 141, 0.97)'
                                                    ) : ('linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)'),
                                                    color: 'white', borderRadius: '8px',
                                                    cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                                }}
                                            ><img src='/Send-Back-Selected32.png' style={{ width: '1rem', height: "1rem", filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
                                            </button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>


                </div>



            </div>



            {
                rejectPanelhide === 2 &&

                <div className='col-12 RejectPanelContainer'>
                    <div className="Rejectpanel">
                        <form action="">

                            <div className="col-12 elements">
                                <div className="row">
                                    <div className="col-3">
                                        <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
                                    </div>
                                    <div className="col-8">
                                        <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                        </form>
                        <div className="col-12 ms-auto my-4">
                            <div className="row">
                                {/* <div className="col-3"></div> */}
                                <div className="col-9 m-auto">
                                    <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")}><img src={submit} style={{ width: '15px' }} /> Reject</button>
                                        <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            }

            {
                rejectPanelhide === 3 &&

                <div className='col-12 RejectPanelContainer'>
                    <div className="Rejectpanel">
                        <form action="">

                            <div className="col-12 elements">
                                <div className="row">
                                    <div className="col-3">
                                        <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
                                    </div>
                                    <div className="col-8">
                                        <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                        </form>
                        <div className="col-12 ms-auto my-4">
                            <div className="row">
                                {/* <div className="col-3"></div> */}
                                <div className="col-9 m-auto">
                                    <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
                                        <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            }

        </>

    )
}

export default AdministrativeApprovalInwards;